import { BaseIconProps } from "@/types/styles.tsx";

function PlusIcon({
    id,
    className,
    size = 24,
    strokeWidth = 2,
    ...rest
}: BaseIconProps) {
    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-download-plan-export"}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M5 12h14" />
            <path d="M12 5v14" />
        </svg>
    );
}

export default PlusIcon;
